// extracted by mini-css-extract-plugin
export default {"Container":"IFAvatar_Container__Uhl9E"};